module.exports = __webpack_public_path__ + "static/media/easyToUse.e7fbec0e.svg";